import React from 'react';
interface TeamMemberProps {
  name: string;
  title: string;
  bio: string;
  imageSrc?: string;
}
export const TeamMemberCard: React.FC<TeamMemberProps> = ({
  name,
  title,
  bio,
  imageSrc
}) => {
  return <div className="bg-dark-700 rounded-lg shadow-lg shadow-black/20 border border-dark-500 overflow-hidden" data-id="element-727">
      {imageSrc && <div className="flex justify-center pt-8" data-id="element-728">
          <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-dark-500" data-id="element-729">
            <img src={imageSrc} alt={name} className="w-full h-full object-cover md:object-cover md:object-[center_20%]" data-id="element-730" />
          </div>
        </div>}
      <div className="p-6 text-center" data-id="element-731">
        <h3 className="text-xl font-bold text-white mb-1" data-id="element-732">{name}</h3>
        <p className="text-[#00c853] font-medium mb-4" data-id="element-733">{title}</p>
        <p className="text-gray-300 text-sm" data-id="element-734">{bio}</p>
      </div>
    </div>;
};